import { connect } from 'react-redux'
import WorkshiftNormalUserComponent from '../../components/openforwork/workshiftNormalUser.component'
import {
  getWorkshiftUser,
  getBillableHourUser,
  getEmployerWorkshift,
  getJournal,
  closeUserWorkshiftSnackbar,
  workshiftPageChange,
  updateUserWorkshift
} from '../../actions'

const mapStateToProps = (state) => {
  const isFilterEmployer = state.workShiftUser.isFilterEmployer
  const workShiftUserRowData = isFilterEmployer
    ? state.workShiftUser.workshiftsUserFilter
    : state.workShiftUser.workShiftUserRow
  const billableHourUserRowData = isFilterEmployer
    ? state.workShiftUser.billableHoursUserFilter
    : state.workShiftUser.billableHourUserRow
  const combinedData = [...workShiftUserRowData, ...billableHourUserRowData]
  // console.log('huong combine data >>>>>>>>>>>>>>>>>>>>>>>>.', combinedData)
  const groupedDataByCompany = groupWorkshiftByCompany(combinedData)
  return {
    state,
    workShiftUserRowData: combinedData,
    employerWorkshiftList: state.workShiftUser.employerWorkshiftList,
    workshiftsUserFilter: state.workShiftUser.workshiftsUserFilter,
    billableHoursUserFilter: state.workShiftUser.billableHoursUserFilter,
    getWorkshiftUserDataSuccess:
      state.workShiftUser.getWorkshiftUserDataSuccess,
    getBillableHourUserDataSuccess:
      state.workShiftUser.getBillableHourUserDataSuccess,
    workshift_journal: state.workShiftUser.workshift_journal,
    showSnackbar: state.workShiftUser.showSnackbar,
    showFailedSnackbar: state.workShiftUser.showFailedSnackbar,
    showSnackbar_update_workshift:
      state.workShiftUser.showSnackbar_update_workshift,
    showFailedSnackbar_update_workshift:
      state.workShiftUser.showFailedSnackbar_update_workshift,
    journalAddSnackbar: state.workShiftUser.journalAddSnackbar,
    journalAddFailedSnackbar: state.workShiftUser.journalAddFailedSnackbar,
    isEditJournal: state.workShiftUser.isEditJournal,
    updateJournalSnackbar: state.workShiftUser.updateJournalSnackbar,
    updateJournalFailSnackbar: state.workShiftUser.updateJournalFailSnackbar,
    selected: state.workShiftUser.selected,
    workshiftPage: !!groupedDataByCompany
      ? Math.ceil(groupedDataByCompany.length / 10)
      : 0,
    saveDraftInvoiceSuccess: state.workShiftUser.saveDraftInvoiceSuccess,
    saveDraftInvoiceFailed: state.workShiftUser.saveDraftInvoiceFailed
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
    getWorkshiftUser: () => dispatch(getWorkshiftUser()),
    getBillableHourUser: () => dispatch(getBillableHourUser()),
    getEmployerWorkshift: () => dispatch(getEmployerWorkshift()),
    getJournal: () => dispatch(getJournal()),
    closeUserWorkshiftSnackbar: () => dispatch(closeUserWorkshiftSnackbar()),
    workshiftPageChange: (selected) => dispatch(workshiftPageChange(selected)),
    updateUserWorkshift: (values, status) =>
      dispatch(updateUserWorkshift(values, status))
  }
}

export const groupWorkshiftByCompany = (workshifts) => {
  return Object.values(
    workshifts.reduce((acc, workshift) => {
      const key = workshift.company_name
      if (!acc[key]) {
        acc[key] = {
          company_name: workshift.company_name,
          workshifts: []
        }
      }
      acc[key].workshifts.push(workshift)
      return acc
    }, {})
  )
}

const mergeProps = (stateProps, dispatchProps, ownProps) =>
  Object.assign({}, stateProps, dispatchProps, ownProps)

const WorkshiftNormalUserContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(WorkshiftNormalUserComponent)

export default WorkshiftNormalUserContainer
